'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubTableInline = undefined;

var _find2 = require('ramda/src/find');

var _find3 = _interopRequireDefault(_find2);

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    text-align: left;\n    position: absolute;\n    width: 100%;\n    left: 100%;\n    right: 0;\n    top: 0;\n    ', '\n'], ['\n    text-align: left;\n    position: absolute;\n    width: 100%;\n    left: 100%;\n    right: 0;\n    top: 0;\n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    clear: both;\n    position: relative;\n    margin-right: ', ';\n    margin-top: 0;\n    ', '\n    ', '\n'], ['\n    clear: both;\n    position: relative;\n    margin-right: ', ';\n    margin-top: 0;\n    ', '\n    ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    width: 100%;\n    max-width: calc(100% - ', ');\n    min-width: 110px;\n    float: left;\n    position: relative;\n'], ['\n    width: 100%;\n    max-width: calc(100% - ', ');\n    min-width: 110px;\n    float: left;\n    position: relative;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: inline-block;\n    color: ', ';\n    font-size: 2em;\n    margin-top: 4px;\n    margin-right: ', ';\n    cursor: ', ';\n'], ['\n    display: inline-block;\n    color: ', ';\n    font-size: 2em;\n    margin-top: 4px;\n    margin-right: ', ';\n    cursor: ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    display: inline-block;\n    max-width: 380px;\n    min-width: 380px;\n'], ['\n    display: inline-block;\n    max-width: 380px;\n    min-width: 380px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFinalForm = require('react-final-form');

var _fa = require('react-icons/fa');

var _reactBeautifulDnd = require('react-beautiful-dnd');

var _popconfirm = require('antd/lib/popconfirm');

var _popconfirm2 = _interopRequireDefault(_popconfirm);

var _experiumPlayerHelpers = require('experium-player-helpers');

var _WorkExperience = require('../functions/WorkExperience');

var _WorkExperience2 = _interopRequireDefault(_WorkExperience);

var _Text = require('../textComponents/Text');

var _Text2 = _interopRequireDefault(_Text);

var _SelectInput = require('./SelectInput');

var _withFieldWrapper = require('../hocs/withFieldWrapper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Buttons = _styledComponents2.default.div(_templateObject, function (_ref) {
    var hasAdditional = _ref.hasAdditional;
    return hasAdditional ? 'padding-top: 14px' : '';
});

var InlineField = _styledComponents2.default.div(_templateObject2, function (_ref2) {
    var single = _ref2.single;
    return single ? '0' : '70px';
}, function (_ref3) {
    var hasAdditional = _ref3.hasAdditional;
    return hasAdditional ? 'padding-top: 14px' : '';
}, function (_ref4) {
    var hasAdditional = _ref4.hasAdditional,
        hasInputSelect = _ref4.hasInputSelect,
        hasWorkFunctionTag = _ref4.hasWorkFunctionTag;
    return hasInputSelect && hasWorkFunctionTag ? hasAdditional ? 'min-height: 65px' : 'min-height: 50px' : '';
});

var WorkFunctionField = _styledComponents2.default.div(_templateObject3, function (_ref5) {
    var inline = _ref5.inline;
    return inline ? '170px' : '240px';
});

var Button = _styledComponents2.default.div(_templateObject4, function (_ref6) {
    var color = _ref6.color;
    return color;
}, function (_ref7) {
    var sort = _ref7.sort;
    return sort ? '0' : '4px';
}, function (_ref8) {
    var disabled = _ref8.disabled;
    return disabled ? 'not-allowed' : 'pointer';
});

var DeleteContent = _styledComponents2.default.span(_templateObject5);

var TableItemInline = function (_Component) {
    _inherits(TableItemInline, _Component);

    function TableItemInline(props) {
        _classCallCheck(this, TableItemInline);

        var _this = _possibleConstructorReturn(this, (TableItemInline.__proto__ || Object.getPrototypeOf(TableItemInline)).call(this, props));

        _this.remove = function () {
            return _this.props.fields.remove(_this.props.index);
        };

        _this.add = function () {
            _this.props.fields.new(_this.props.index, {});
        };

        _this.addLast = function () {
            return _this.props.fields.push();
        };

        _this.itemRef = _react2.default.createRef();
        return _this;
    }

    _createClass(TableItemInline, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                index = _props.index,
                length = _props.fields.length,
                viewMode = _props.viewMode,
                isSort = _props.isSort,
                isSave = _props.isSave,
                hasAdditional = _props.hasAdditional,
                hasInputSelect = _props.hasInputSelect;

            var isSingle = this.props.item.single;
            var items = this.props.item.items || [];

            var _$split = ('' + (this.props.name || '')).split('['),
                _$split2 = _slicedToArray(_$split, 1),
                tableName = _$split2[0];

            var hasWorkFunction = (0, _path3.default)(['function'], this.props.item) === 'calc_work_experience';
            var hasWorkFunctionTag = hasWorkFunction && (0, _find3.default)(function (item) {
                return (0, _path3.default)(['function_tag'], item) === 'to';
            }, this.props.item.items);

            var disableDelete = !(length > 1);
            var deleteTitle = _react2.default.createElement(
                DeleteContent,
                null,
                _react2.default.createElement(
                    'b',
                    null,
                    _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'deleteConfirm' })
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'deleteDescription' })
            );

            return _react2.default.createElement(
                InlineField,
                { innerRef: this.itemRef, single: isSingle, hasAdditional: hasAdditional, hasInputSelect: hasInputSelect, hasWorkFunctionTag: hasWorkFunctionTag, index: !index },
                hasWorkFunction && hasWorkFunctionTag ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        WorkFunctionField,
                        { inline: true },
                        this.props.children
                    ),
                    _react2.default.createElement(
                        _reactFinalForm.Field,
                        { name: tableName },
                        function (_ref9) {
                            var input = _ref9.input;
                            return _react2.default.createElement(_WorkExperience2.default, {
                                items: items,
                                index: _this2.props.index,
                                value: (0, _path3.default)(['value', _this2.props.index], input),
                                values: (0, _path3.default)(['value'], input) || [],
                                inline: true
                            });
                        }
                    )
                ) : this.props.children,
                isSingle || viewMode ? null : _react2.default.createElement(
                    Buttons,
                    { hasAdditional: hasAdditional },
                    _react2.default.createElement(
                        Button,
                        { onClick: this.add, color: '#569e3a' },
                        _react2.default.createElement(_fa.FaPlusCircle, null)
                    ),
                    _react2.default.createElement(
                        _popconfirm2.default,
                        {
                            placement: 'leftTop',
                            title: deleteTitle,
                            okText: _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'deleteOk' }),
                            cancelText: _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'deleteCancel' }),
                            onConfirm: this.remove,
                            icon: null,
                            getPopupContainer: function getPopupContainer() {
                                return _this2.itemRef.current;
                            },
                            disabled: !isSave || disableDelete
                        },
                        _react2.default.createElement(
                            Button,
                            { sort: true, disabled: disableDelete, onClick: isSave || disableDelete ? undefined : this.remove, color: '#e94f34' },
                            _react2.default.createElement(_fa.FaTimesCircle, null)
                        )
                    ),
                    isSort && _react2.default.createElement(
                        Button,
                        { sort: true, color: '#555' },
                        _react2.default.createElement(_fa.FaArrowsAltV, null)
                    )
                )
            );
        }
    }]);

    return TableItemInline;
}(_react.Component);

TableItemInline.propTypes = {
    children: _propTypes2.default.node,
    name: _propTypes2.default.string,
    item: _propTypes2.default.object,
    index: _propTypes2.default.number,
    viewMode: _propTypes2.default.bool,
    isSort: _propTypes2.default.bool,
    isSave: _propTypes2.default.bool,
    hasAdditional: _propTypes2.default.bool,
    hasInputSelect: _propTypes2.default.bool,
    fields: _propTypes2.default.object
};

var TableInline = function (_Component2) {
    _inherits(TableInline, _Component2);

    function TableInline() {
        var _ref10;

        var _temp, _this3, _ret;

        _classCallCheck(this, TableInline);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref10 = TableInline.__proto__ || Object.getPrototypeOf(TableInline)).call.apply(_ref10, [this].concat(args))), _this3), _this3.onDragEnd = function (result) {
            var fields = _this3.props.fields;
            var source = result.source,
                destination = result.destination;


            if (!destination) {
                return;
            }

            fields.move(source.index, destination.index);

            setTimeout(function () {
                _this3.props.fields.new(0, {});
                _this3.props.fields.remove(0);
            }, 100);
        }, _temp), _possibleConstructorReturn(_this3, _ret);
    }

    _createClass(TableInline, [{
        key: 'render',
        value: function render() {
            var _this4 = this;

            var viewMode = this.props.viewMode;

            var isSort = this.props.item.sorting === true;
            var css = (0, _withFieldWrapper.getStyle)(this.props.item.css);
            var items = this.props.item.items || [];
            var header = items.find(function (item) {
                return item.type === 'h1' || item.type === 'h2' || item.type === 'h3' || item.type === 'h4';
            });
            var labelText = (0, _experiumPlayerHelpers.getText)(header || (0, _path3.default)(['items', 0], this.props.item), this.props.language);
            var isSave = this.props.item.dbsave === true || !!items.find(function (item) {
                return item.dbsave === true;
            });
            var hasInputSelect = !!items.find(function (item) {
                return (0, _SelectInput.isInputSelect)(item.function);
            });

            return _react2.default.createElement(
                _withFieldWrapper.StyledItem,
                {
                    cssStyle: css.style,
                    className: 'styled-item-inline ' + (css.className || ''),
                    background: this.props.item.background,
                    inline: true,
                    hasAdditional: hasInputSelect,
                    hasInputSelect: hasInputSelect
                },
                _react2.default.createElement(
                    _withFieldWrapper.Label,
                    null,
                    labelText ? _react2.default.createElement(_Text2.default, { text: labelText }) : ''
                ),
                _react2.default.createElement(
                    _withFieldWrapper.FieldWrapper,
                    { className: 'field-inline', subField: true },
                    isSort ? _react2.default.createElement(
                        _reactBeautifulDnd.DragDropContext,
                        { onDragEnd: this.onDragEnd },
                        _react2.default.createElement(
                            _reactBeautifulDnd.Droppable,
                            { droppableId: this.props.name },
                            function (provided) {
                                return _react2.default.createElement(
                                    'div',
                                    _extends({ ref: provided.innerRef }, provided.droppableProps),
                                    _this4.props.fields.map(function (name, index) {
                                        return _react2.default.createElement(
                                            _reactBeautifulDnd.Draggable,
                                            {
                                                key: 'drag-' + name + '-' + _this4.props.fields.length + '-' + index,
                                                draggableId: 'id-' + name + '-' + index,
                                                index: index,
                                                isDragDisabled: viewMode
                                            },
                                            function (providedD) {
                                                return _react2.default.createElement(
                                                    'div',
                                                    _extends({
                                                        ref: providedD.innerRef
                                                    }, providedD.draggableProps, providedD.dragHandleProps, {
                                                        style: _extends({}, providedD.draggableProps.style)
                                                    }),
                                                    _react2.default.createElement(
                                                        TableItemInline,
                                                        {
                                                            key: 'sub-' + name + '-' + index,
                                                            name: _this4.props.name,
                                                            item: _this4.props.item,
                                                            fields: _this4.props.fields,
                                                            viewMode: viewMode,
                                                            isSort: isSort,
                                                            isSave: isSave,
                                                            index: index,
                                                            hasAdditional: hasInputSelect && !!index,
                                                            hasInputSelect: hasInputSelect
                                                        },
                                                        _this4.props.children(name, header ? items.length - 1 : items.length, index)
                                                    )
                                                );
                                            }
                                        );
                                    }),
                                    provided.placeholder
                                );
                            }
                        )
                    ) : this.props.fields.map(function (name, index) {
                        return _react2.default.createElement(
                            TableItemInline,
                            {
                                key: 'sub-' + name + '-' + index,
                                name: _this4.props.name,
                                item: _this4.props.item,
                                fields: _this4.props.fields,
                                viewMode: _this4.props.viewMode,
                                isSave: isSave,
                                index: index,
                                hasAdditional: hasInputSelect && !!index,
                                hasInputSelect: hasInputSelect
                            },
                            _this4.props.children(name, header ? items.length - 1 : items.length, index)
                        );
                    })
                )
            );
        }
    }]);

    return TableInline;
}(_react.Component);

TableInline.propTypes = {
    name: _propTypes2.default.string,
    language: _propTypes2.default.string,
    viewMode: _propTypes2.default.bool,
    item: _propTypes2.default.object,
    fields: _propTypes2.default.object,
    children: _propTypes2.default.func
};
exports.default = TableInline;

var SubTableInline = exports.SubTableInline = function (_Component3) {
    _inherits(SubTableInline, _Component3);

    function SubTableInline() {
        _classCallCheck(this, SubTableInline);

        return _possibleConstructorReturn(this, (SubTableInline.__proto__ || Object.getPrototypeOf(SubTableInline)).apply(this, arguments));
    }

    _createClass(SubTableInline, [{
        key: 'render',
        value: function render() {
            var _this6 = this;

            var css = (0, _withFieldWrapper.getStyle)(this.props.item.css);
            var items = this.props.item.items || [];
            var header = items.find(function (item) {
                return item.type === 'h1';
            });
            var labelText = (0, _experiumPlayerHelpers.getText)(header || (0, _path3.default)(['items', 0], this.props.item), this.props.language);
            var hasWorkFunction = (0, _path3.default)(['function'], this.props.parent) === 'calc_work_experience';
            var hasWorkFunctionTag = hasWorkFunction && (0, _find3.default)(function (item) {
                return (0, _path3.default)(['function_tag'], item) === 'to';
            }, this.props.item.items);

            var _$split3 = ('' + (this.props.name || '')).split('['),
                _$split4 = _slicedToArray(_$split3, 1),
                tableName = _$split4[0];

            return _react2.default.createElement(
                _withFieldWrapper.StyledItem,
                { cssStyle: css.style, className: 'styled-item-subinline ' + css.className, inline: true },
                _react2.default.createElement(
                    _withFieldWrapper.Label,
                    null,
                    labelText ? _react2.default.createElement(_Text2.default, { text: labelText }) : ''
                ),
                _react2.default.createElement(
                    _withFieldWrapper.FieldWrapper,
                    { subField: true },
                    hasWorkFunction && hasWorkFunctionTag ? _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            WorkFunctionField,
                            null,
                            this.props.children
                        ),
                        _react2.default.createElement(
                            _reactFinalForm.Field,
                            { name: tableName },
                            function (_ref11) {
                                var input = _ref11.input;
                                return _react2.default.createElement(_WorkExperience2.default, {
                                    items: items,
                                    index: _this6.props.index,
                                    value: (0, _path3.default)(['value', _this6.props.index], input),
                                    values: (0, _path3.default)(['value'], input) || []
                                });
                            }
                        )
                    ) : this.props.children
                )
            );
        }
    }]);

    return SubTableInline;
}(_react.Component);

SubTableInline.propTypes = {
    name: _propTypes2.default.string,
    language: _propTypes2.default.string,
    index: _propTypes2.default.number,
    parent: _propTypes2.default.object,
    item: _propTypes2.default.object,
    fields: _propTypes2.default.object,
    children: _propTypes2.default.array
};